/**
 * @desc 扫描任务编号获取任务明细
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inventoryMaster.taskDetail.Params, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/taskDetailByTono`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
